import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../Components/CSS/RaceCardCSS/racecard.css";
import Layout from "../Components/Reuseable/layout";
import Footer from "../Components/Reuseable/Footer";
import CopyRight from "../Components/Reuseable/Copyrights";
import "../Components/CSS/pagesCSS/stats.css";
import Animate from "../assets/loader.json";
import Lottie from "lottie-react";
import Cookies from "js-cookie";
import Moment from "react-moment";
import moment from "moment";
import Pagination from "./Pagination";
import Select from "react-select";
import {
  fetchResultDates,
} from "../../Webiste/redux//getQueryReducer/getResultDates";
import { fetchResultHorseId } from "../../Webiste/redux//getQueryReducer/getResultHorseId";
import { fetchResultJockey } from "../../Webiste/redux//getQueryReducer/getResultJockey";
import { fetchResultNationality } from "../../Webiste/redux//getQueryReducer/getResultNationality";
import { fetchResultOwner } from "../../Webiste/redux//getQueryReducer/getResultOwner";
import { fetchResultRaceCourse } from "../../Webiste/redux//getQueryReducer/getResultRaceCourse";
import { fetchResultRaceGround } from "../../Webiste/redux//getQueryReducer/getResultRaceGround";
import { fetchResultRaceTracklength } from "../../Webiste/redux//getQueryReducer/getResultRaceTracklength";
import { fetchResultRaceType } from "../../Webiste/redux//getQueryReducer/getResultRaceType";
import { fetchResultTrainer } from "../../Webiste/redux//getQueryReducer/getResultTrainer";
import { fetchResultYearDropdown } from "../../Webiste/redux//getQueryReducer/getResultYearDropdown";
import { fetchResultMeeting } from "../../Webiste/redux//getQueryReducer/getResultMeeting";
import { fetchQueryTool, STATUSES } from "../../Webiste/redux//getQueryReducer/getMainQueryTool";
import { fetchResultSponsor } from "../../Webiste/redux//getQueryReducer/getResultSponsor";
import { fetchHorseKindDropDown } from "../../Webiste/redux//getQueryReducer/getResultHorseKind";
import HorseModal from '../Components/Modal/HorseModal'
import JockeyModal from '../Components/Modal/JockeyModal'
import TrainerModal from '../Components/Modal/TrainerModal';
import OwnerModal from "../Components/Modal/OwnerModal";
import RaceModal from "../Components/Modal/RaceModal";
import { fetchSponsor } from "../redux/getReducer/getSponsorSlice"
import { truncateRaceType } from "../service/stringUtils";

import Carousel from "react-bootstrap/Carousel";

import DefaultImg from "../assets/default.png";
import { Modal } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import { AiOutlineBars } from "react-icons/ai";
import { FaBars } from "react-icons/fa";

const Stats = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cookiedata = Cookies.get("i18next");
  const { data: ResultYearDropdown } = useSelector(
    (state) => state.ResultYearDropdown
  );
  const { data: ResultDates } = useSelector((state) => state.ResultDates);
  const { data: ResultRaceCourse } = useSelector(
    (state) => state.ResultRaceCourse
  );
  const { data: ResultRaceType } = useSelector((state) => state.ResultRaceType);

  const { data: ResultNationality } = useSelector(
    (state) => state.ResultNationality
  );
  const { data: ResultRaceGround } = useSelector(
    (state) => state.ResultRaceGround
  );
  const { data: ResultRaceTracklength } = useSelector(
    (state) => state.ResultRaceTracklength
  );



  const { data: sponsor } = useSelector((state) => state.sponsor);

  useEffect(() => {
    dispatch(fetchSponsor());
  }, [dispatch]);



  const [userIsDesktop, setUserIsDesktop] = useState(true);
  useEffect(() => {
    window.innerWidth > 840 ? setUserIsDesktop(true) : setUserIsDesktop(false);
  }, [userIsDesktop]);







  const { data: ResultHorseId } = useSelector((state) => state.ResultHorseId);
  const { data: ResultTrainer } = useSelector((state) => state.ResultTrainer);
  const { data: ResultMeeting } = useSelector((state) => state.ResultMeeting);
  const { data: ResultJockey } = useSelector((state) => state.ResultJockey);
  const { data: ResultOwner } = useSelector((state) => state.ResultOwner);
  const { data: QueryTool, status } = useSelector((state) => state.QueryTool);
  const { data: ResultSponsor } = useSelector((state) => state.ResultSponsor);
  const { data: HorseKindDropDown } = useSelector((state) => state.HorseKindDropDown);

  const [ResultYearData, setResultYearData] = useState("");
  const [ResultDatesData, setResultDates] = useState("");
  const [ResultRaceCourseData, setResultRaceCourse] = useState("");
  const [ResultRaceTypeData, setResultRaceType] = useState("");
  const [ResultNationalityData, setResultNationality] = useState("");
  const [ResultRaceGroundData, setResultRaceGround] = useState("");
  const [ResultRaceTracklengthData, setResultRaceTracklength] = useState("");
  const [ResultHorseIdData, setResultHorseId] = useState("");
  const [ResultTrainerData, setResultTrainer] = useState("");
  const [ResultMeetingData, setResultMeeting] = useState("");
  const [ResultJockeyData, setResultJockey] = useState("");
  const [ResultOwnerData, setResultOwner] = useState("");
  const [ResultSponsorData, setResultSponsor] = useState("");
  const [ResultHorseKindData, setResultHorseKind] = useState("");

  const { t } = useTranslation();
  let totalcountdata = QueryTool ? QueryTool.totalcount : '';
  let totalpagesdata = QueryTool.totalcount;
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(15);
  const [TotalCount, setTotalCount] = useState(100);
  const [TotalPages, setTotalPages] = useState(9);


  const [Value1, setValue1] = useState("");
  const [Value2, setValue2] = useState("");
  const [Value3, setValue3] = useState("");
  const [Value4, setValue4] = useState("");
  const [Value5, setValue5] = useState("");
  const [Value6, setValue6] = useState("");
  const [Value7, setValue7] = useState("");
  const [Value8, setValue8] = useState("");
  const [Value9, setValue9] = useState("");
  const [Value10, setValue10] = useState("");
  const [Value11, setValue11] = useState("");
  const [Value12, setValue12] = useState("");
  const [Value13, setValue13] = useState("");

  const [IncreasePage, setIncreasePage] = useState(16);

  const [IncreasePage1, setIncreasePage1] = useState(16);

  const [IncreasePage2, setIncreasePage2] = useState(16);
  const [IncreasePage3, setIncreasePage3] = useState(16);
  const [IncreasePage4, setIncreasePage4] = useState(16);
  const [IncreasePage5, setIncreasePage5] = useState(16);
  const [IncreasePage6, setIncreasePage6] = useState(16);
  const [IncreasePage7, setIncreasePage7] = useState(16);
  const [IncreasePage8, setIncreasePage8] = useState(16);
  const [IncreasePage9, setIncreasePage9] = useState(16);
  const [IncreasePage10, setIncreasePage10] = useState(16);
  const [IncreasePage11, setIncreasePage11] = useState(16);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);



  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();

  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };




  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();

  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };



  const [showJockey, setShowJockey] = useState(false);
  const [modaldataJockey, setmodaldataJockey] = useState();

  const handleCloseJockey = () => setShowJockey(false);
  const handleShowJockey = (data) => { const id = data?._id || data; if (id) navigate("/jockey-detail?" + id); };



  const [showTrainer, setShowTrainer] = useState(false);
  const [modaldataTrainer, setmodaldataTrainer] = useState();

  const handleCloseTrainer = () => setShowTrainer(false);
  const handleShowTrainer = (data) => { const id = data?._id || data; if (id) navigate("/trainer-detail?" + id); };

  const [showQuery, setShowQuery] = useState(false);



  const [showOwner, setShowOwner] = useState(false);
  const [modaldataOwner, setmodaldataOwner] = useState();

  const handleCloseOwner = () => setShowOwner(false);
  const handleShowOwner = (data) => { const id = data?._id || data; if (id) navigate("/owner-detail?" + id); };

  const handlequery = () => {
    setShowQuery(!showQuery)
  }


  let uniqueTrackLengths = {};

  // Create a new array to store items with unique TrackLength values
  let filteredData = [];

  // Iterate through the original array
  for (let item of ResultRaceTracklength) {
    let trackLength = item["TrackLength"];

    // Check if the TrackLength value is not already in the uniqueTrackLengths object
    if (!uniqueTrackLengths[trackLength]) {
      // Add the TrackLength value to the uniqueTrackLengths object and add the item to the filteredData array
      uniqueTrackLengths[trackLength] = true;
      filteredData.push(item);
    }
  }







  let RaceCourseData = ResultRaceCourse.map(function (item) {
    return {
      id: item._id,
      value: item.TrackNameEn,
      label: item.TrackNameEn,
    };
  });

  let RaceHorseKindDropDown = HorseKindDropDown.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });

  let RaceHorseKindDropDownAr = HorseKindDropDown.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });


  let RaceCourseDataAr = ResultRaceCourse.map(function (item) {
    return {
      id: item._id,
      value: item.TrackNameAr,
      label: item.TrackNameAr,
    };
  });


  let RaceDateYearData = ResultYearDropdown.map(function (item) {
    return {
      id: item._id,
      value: item.ResultYear,
      label: item.ResultYear,
    };
  });

  let RaceDateData = ResultDates.map(function (item) {
    return {
      id: item._id,
      value: item.ResultYear,
      label: item.ResultYear,
    };
  });

  let RaceCountryDropdown = ResultNationality.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });


  let RaceCountryDropdownAr = ResultNationality.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });


  let RaceTypeDropdown = ResultRaceType.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });


  let RaceTypeDropdownAr = ResultRaceType.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });



  let RaceMeetingDropdown = ResultMeeting.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });

  let RaceMeetingDropdownAr = ResultMeeting.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });


  let RaceGroundDropdown = ResultRaceGround.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });


  let RaceGroundDropdownAr = ResultRaceGround.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });

  let RaceTrackDropdown = filteredData && filteredData?.map(function (item) {
    return {
      id: item._id,
      value: item.TrackLength,
      label: item.TrackLength,
    };
  });

  let RaceHorseDropdown = ResultHorseId.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });


  let RaceHorseDropdownAr = ResultHorseId.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });

  let RaceJockeyDropdown = ResultJockey.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });
  let RaceJockeyDropdownAr = ResultJockey.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });

  let RaceTrainerDropdown = ResultTrainer.data && ResultTrainer.data.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });

  let RaceTrainerDropdownAr = ResultTrainer.data && ResultTrainer.data.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });



  let RaceOwnerDropdown = ResultOwner.map(function (item) {
    return {
      id: item._id,
      value: item.NameEn,
      label: item.NameEn,
    };
  });


  let RaceOwnerDropdownAr = ResultOwner.map(function (item) {
    return {
      id: item._id,
      value: item.NameAr,
      label: item.NameAr,
    };
  });


  let RaceSponsorDropdown = ResultSponsor.map(function (item) {
    return {
      id: item._id,
      value: item.TitleEn,
      label: item.TitleEn,
    };
  });


  let RaceSponsorDropdownAr = ResultSponsor.map(function (item) {
    return {
      id: item._id,
      value: item.TitleAr,
      label: item.TitleAr,
    };
  });

  let data2 = ResultHorseIdData ? (ResultHorseIdData.id === undefined ? '' : ResultHorseIdData.id) : "";
  let data3 = ResultTrainerData ? (ResultTrainerData.id === undefined ? '' : ResultTrainerData.id) : "";
  let data5 = ResultRaceCourseData ? (ResultRaceCourseData.id === undefined ? '' : ResultRaceCourseData.id) : "";
  let data4 = ResultJockeyData ? (ResultJockeyData.id === undefined ? '' : ResultJockeyData.id) : "";
  let data1 = ResultDatesData ? (ResultDatesData.value === undefined ? '' : ResultDatesData.value) : "";
  let data6 = ResultNationalityData ? (ResultNationalityData.id === undefined ? '' : ResultNationalityData.id) : "";
  let data7 = ResultRaceTypeData ? (ResultRaceTypeData.id === undefined ? '' : ResultRaceTypeData.id) : "";
  let data8 = ResultRaceGroundData ? (ResultRaceGroundData.id === undefined ? '' : ResultRaceGroundData.id) : "";
  let data9 = ResultRaceTracklengthData ? (ResultRaceTracklengthData.id === undefined ? '' : ResultRaceTracklengthData.id) : "";
  let data10 = ResultOwnerData ? (ResultOwnerData.id === undefined ? '' : ResultOwnerData.id) : "";
  let data11 = ResultMeetingData ? (ResultMeetingData.id === undefined ? '' : ResultMeetingData.id) : "";
  let data12 = ResultSponsorData ? (ResultSponsorData.id === undefined ? '' : ResultSponsorData.id) : "";
  let data13 = ResultHorseKindData ? (ResultHorseKindData.id === undefined ? '' : ResultHorseKindData.id) : "";
  let data14 = ResultYearData ? (ResultYearData.value === undefined ? '' : ResultYearData.value) : "";

  useEffect(() => {
    dispatch(fetchResultDates({
      Value1,
      data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14,
    }));

  }, [dispatch, Value1, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14,]);


  useEffect(() => {
    dispatch(fetchResultHorseId({
      Value9, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage7
    }));

  }, [IncreasePage7, Value9,
    data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, dispatch])

  useEffect(() => {
    dispatch(fetchResultTrainer({
      Value11, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage9
    }));

  }, [dispatch, Value11, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage9]);

  useEffect(() => {
    dispatch(fetchResultJockey({
      Value10, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage8
    }));

  }, [dispatch, Value10, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage8]);

  useEffect(() => {
    dispatch(fetchResultNationality({
      Value4, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage2
    }));

  }, [dispatch, Value4, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage2]);

  useEffect(() => {
    dispatch(fetchResultRaceCourse({
      Value3,
      data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage
    }));

  }, [dispatch, Value3, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage]);

  useEffect(() => {
    dispatch(fetchResultRaceGround({
      Value7, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage5
    }));

  }, [dispatch, Value7, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage5]);

  useEffect(() => {
    dispatch(fetchResultRaceTracklength({
      Value8, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage6
    }));

  }, [dispatch, Value8, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage6]);

  useEffect(() => {
    dispatch(fetchResultRaceType({
      Value5, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage3
    }));

  }, [dispatch, Value5, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage3]);

  useEffect(() => {
    dispatch(fetchResultYearDropdown({
      Value2,
      data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage1
    }));

  }, [dispatch, Value2, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage1]);

  useEffect(() => {
    dispatch(fetchResultMeeting({
      Value6, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage4
    }));

  }, [dispatch, Value6, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage4]);

  useEffect(() => {
    dispatch(fetchResultOwner({
      Value12, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage10
    }));

  }, [dispatch, Value12, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage10]);


  useEffect(() => {
    dispatch(fetchResultSponsor({
      Value13, data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      data9,
      data10,
      data11,
      data12,
      data13,
      data14, IncreasePage11
    }));

  }, [dispatch, Value13, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14, IncreasePage11]);

  const handleOnScrollBottom = () => {
    setIncreasePage(IncreasePage + 12)
    dispatch(fetchResultRaceCourse({ Value3, IncreasePage }));
  };

  const handleOnScrollBottom1 = () => {
    setIncreasePage1(IncreasePage1 + 12)
    dispatch(fetchResultYearDropdown({ Value2, IncreasePage1 }));
  };

  const handleOnScrollBottom2 = () => {
    setIncreasePage2(IncreasePage2 + 12)
    dispatch(fetchResultNationality({ Value4, IncreasePage2 }));
  };
  const handleOnScrollBottom3 = () => {
    setIncreasePage3(IncreasePage3 + 12)
    dispatch(fetchResultRaceType({ Value5, IncreasePage3 }));
  };
  const handleOnScrollBottom4 = () => {
    setIncreasePage4(IncreasePage4 + 12)
    dispatch(fetchResultMeeting({ Value6, IncreasePage4 }));
  };
  const handleOnScrollBottom5 = () => {
    setIncreasePage5(IncreasePage5 + 12)
    dispatch(fetchResultRaceGround({ Value7, IncreasePage5 }));
  };

  const handleOnScrollBottom6 = () => {
    setIncreasePage6(IncreasePage6 + 12)
    dispatch(fetchResultRaceTracklength({ Value8, IncreasePage6 }));
  };
    // Bumping IncreasePage triggers the matching useEffect, which refetches with all
  // active filters (incl. HorseKindinRace); dispatching here without them would
  // overwrite the filtered list with unfiltered results.
  const handleOnScrollBottom7 = () => {
    setIncreasePage7(IncreasePage7 + 12)
  };

  const handleOnScrollBottom8 = () => {
    setIncreasePage8(IncreasePage8 + 12)
  };

  const handleOnScrollBottom9 = () => {
    if (ResultTrainer.totalcount > IncreasePage9) {
      setIncreasePage9(IncreasePage9 + 12)
    }
    else {

    }

  };
  const handleOnScrollBottom10 = () => {
    setIncreasePage10(IncreasePage10 + 12)
  };
  const handleOnScrollBottom11 = () => {
    setIncreasePage11(IncreasePage11 + 12)
    dispatch(fetchResultSponsor({ Value13, IncreasePage11 }));
  };





  useEffect(() => {
    dispatch(fetchHorseKindDropDown());
    dispatch(
      fetchQueryTool({
        data1,
        data2,
        data3,
        data4,
        data5,
        data6,
        data7,
        data8,
        data9,
        data10,
        data11,
        data12,
        data13,
        data14,
        currentPage,
      })

    );

    setTotalCount(totalcountdata)
  }, [dispatch, currentPage, data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12,
    data13,
    data14,]);






  const GenerateReport = () => {
    dispatch(
      fetchQueryTool({
        data1,
        data2,
        data3,
        data4,
        data5,
        data6,
        data7,
        data8,
        data9,
        data10,
        data11,
        data12,
        data13,
        data14,
        currentPage
      })
    );
  };

  const ClearAll = () => {
    setResultYearData("")
    setResultDates("")
    setResultRaceCourse("")
    setResultRaceType("")
    setResultNationality("")
    setResultRaceGround("")
    setResultRaceTracklength("")
    setResultTrainer("")
    setResultMeeting("")
    setResultJockey("")
    setResultOwner("")
    setResultSponsor("")
    setResultHorseKind("")
    setResultHorseId("")
  }

  const handleChangeInput = (value) => {
    setValue1(value);
  };

  const handleChangeInput1 = (value) => {
    setValue2(value);
  };
  const handleChangeInput2 = (value) => {
    setValue3(value);
  };
  const handleChangeInput3 = (value) => {
    setValue4(value);
  };
  const handleChangeInput4 = (value) => {
    setValue5(value);
  };
  const handleChangeInput5 = (value) => {
    setValue6(value);
  };
  const handleChangeInput6 = (value) => {
    setValue7(value);
  };
  const handleChangeInput7 = (value) => {
    setValue8(value);
  };
  const handleChangeInput8 = (value) => {
    setValue9(value);
  };
  const handleChangeInput9 = (value) => {
    setValue10(value);
  };
  const handleChangeInput10 = (value) => {
    setValue11(value);
  };
  const handleChangeInput11 = (value) => {
    setValue12(value);
  };

  const handleChangeInput13 = (value) => {
    setValue13(value);
  };

  function formatAMPM(date) {
    const data1 = new Date(date);
    var hours = data1.getHours();
    var minutes = data1.getMinutes();
    var ampm = hours >= 12 ? t("PM") : t("AM");
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }


  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#0c1a3e',
      border: 'none',
      borderRadius: '8px',
      minHeight: '38px',
      color: 'white',
      marginBottom: '8px',
      cursor: 'pointer',
      boxShadow: 'none'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'white'
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9da7be',
      fontSize: '13px'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: 'white'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: '#fff',
      padding: '0 8px'
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '2px 8px',
      overflow: 'hidden'
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      opacity: 0   // 🔥 THIS FIXES THE CURSOR LINE
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#0c1a3e',
      zIndex: 9999
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#2173d1' : '#0c1a3e',
      color: 'white',
      fontSize: '13px',
      cursor: 'pointer'
    })
  };



  return (
    <>
      <div className="new-query-tool-wrapper">
        <div className="container-fluid new-main-layout">
          <div className="row">
            {/* LEFT SIDEBAR FILTERS */}
            <div className="col-lg-3">
              <div className="new-sidebar-filter-card">
                {/* <button className="new-report-btn" onClick={GenerateReport}>{t("Generate Report")}</button> */}
                <p className="new-reset-link" onClick={ClearAll}>{t("Reset All")}</p>
                <div className="new-filter-stack">
                  <Select styles={customStyles} placeholder={t("Year")} options={RaceDateYearData} onChange={setResultYearData} value={ResultYearData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput} onMenuScrollToBottom={handleOnScrollBottom1} />
                  <Select styles={customStyles} placeholder={t("Date")} options={RaceDateData} onChange={setResultDates} value={ResultDatesData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput1} />
                  <Select styles={customStyles} placeholder={t("Race Course")} options={cookiedata === "en" ? RaceCourseData : RaceCourseDataAr} onChange={setResultRaceCourse} value={ResultRaceCourseData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput2} onMenuScrollToBottom={handleOnScrollBottom} />
                  <Select styles={customStyles} placeholder={t("Nationality")} options={cookiedata === "en" ? RaceCountryDropdown : RaceCountryDropdownAr} onChange={setResultNationality} value={ResultNationalityData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput3} onMenuScrollToBottom={handleOnScrollBottom2} />
                  <Select styles={customStyles} placeholder={t("Race Type")} options={cookiedata === "en" ? RaceTypeDropdown : RaceTypeDropdownAr} onChange={setResultRaceType} value={ResultRaceTypeData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput4} onMenuScrollToBottom={handleOnScrollBottom3} />
                  <Select styles={customStyles} placeholder={t("Meeting Type")} options={cookiedata === "en" ? RaceMeetingDropdown : RaceMeetingDropdownAr} onChange={setResultMeeting} value={ResultMeetingData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput5} onMenuScrollToBottom={handleOnScrollBottom4} />
                  <Select styles={customStyles} placeholder={t("Ground Type")} options={cookiedata === "en" ? RaceGroundDropdown : RaceGroundDropdownAr} onChange={setResultRaceGround} value={ResultRaceGroundData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput6} onMenuScrollToBottom={handleOnScrollBottom5} />
                  <Select styles={customStyles} placeholder={t("KindOfHorse")} options={cookiedata === "en" ? RaceHorseKindDropDown : RaceHorseKindDropDownAr} onChange={setResultHorseKind} value={ResultHorseKindData} isSearchable isClearable hideSelectedOptions />
                  <Select styles={customStyles} placeholder={t("Track length")} options={RaceTrackDropdown} onChange={setResultRaceTracklength} value={ResultRaceTracklengthData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput7} onMenuScrollToBottom={handleOnScrollBottom6} />
                  <Select styles={customStyles} placeholder={t("Horse")} options={cookiedata === "en" ? RaceHorseDropdown : RaceHorseDropdownAr} onChange={setResultHorseId} value={ResultHorseIdData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput8} onMenuScrollToBottom={handleOnScrollBottom7} />
                  <Select styles={customStyles} placeholder={t("Jockey")} options={cookiedata === "en" ? RaceJockeyDropdown : RaceJockeyDropdownAr} onChange={setResultJockey} value={ResultJockeyData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput9} onMenuScrollToBottom={handleOnScrollBottom8} />
                  <Select styles={customStyles} placeholder={t("Trainer")} options={cookiedata === "en" ? RaceTrainerDropdown : RaceTrainerDropdownAr} onChange={setResultTrainer} value={ResultTrainerData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput10} onMenuScrollToBottom={handleOnScrollBottom9} />
                  <Select styles={customStyles} placeholder={t("Owner")} options={cookiedata === "en" ? RaceOwnerDropdown : RaceOwnerDropdownAr} onChange={setResultOwner} value={ResultOwnerData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput11} onMenuScrollToBottom={handleOnScrollBottom10} />
                  <Select styles={customStyles} placeholder={t("sponsors")} options={cookiedata === "en" ? RaceSponsorDropdown : RaceSponsorDropdownAr} onChange={setResultSponsor} value={ResultSponsorData} isSearchable isClearable hideSelectedOptions onInputChange={handleChangeInput13} onMenuScrollToBottom={handleOnScrollBottom11} />
                </div>
              </div>
            </div>

            {/* RIGHT RESULTS COLUMN */}
            <div className="col-lg-9">
              <div className="new-results-table-card">
                {status !== 'idle' ? (
                  <div className="new-centered-loader">
                    <Lottie animationData={Animate} style={{ width: '120px' }} />
                  </div>
                ) : (
                  <>
                    <div className="new-table-responsive-container">
                      <div className="new-grid-table">
                        <div className="my-new-grid-thead">
                          <div>{t("Date")}</div><div>{t("Time")}</div><div>{t("Course")}</div><div>{t("RN")}</div><div>{t("Horse")}</div><div>{t("Length")}</div><div>{t("Win Time")}</div><div>{t("Kind")}</div><div>{t("Jockey")}</div><div>{t("Trainer")}</div><div>{t("Owner")}</div><div>{t("Type")}</div>
                        </div>
                        <div className="new-grid-tbody">
                          {QueryTool.data?.map((item, index) => (
                            <div key={index} className="new-trow-grid">
                              <div onClick={() => handleShowRace(item.RaceID)} className="new-clickable"><Moment format="DD/MM/YYYY">{item.StartTimeOfRace}</Moment></div>
                              <div>{formatAMPM(item?.StartTimeOfRace)}</div>
                              <div>
                                {cookiedata === "en" ? (window.textTransform(item.RaceCourseOfRaceData?.TrackNameEn || "-")) : item.RaceCourseOfRaceData?.TrackNameAr || "-"}
                                ({cookiedata === "en" ? (item.RaceGroundData?.NameEn?.charAt(0) || "-") : item.RaceGroundData?.NameAr || "-"})
                              </div>
                              <div>{item.RaceResultData?.RaceNumber || "-"}</div>
                              <div onClick={() => handleShow(item.HorseID)} className="new-clickable">{cookiedata === "en" ? window.textTransform(item.HorseIDData?.NameEn || "-") : item.HorseIDData?.NameAr || "-"}</div>
                              <div>{item.RaceTracklengthData?.TrackLength || "-"}</div>
                              <div>{item.RaceTime || "-"}</div>
                              <div>{cookiedata === "en" ? window.textTransform(item.HorseIDData?.KindHorseData?.NameEn || "-") : item.HorseIDData?.KindHorseData?.NameAr || "-"}</div>
                              <div onClick={() => handleShowJockey(item.JockeyOnRace)} className="new-clickable">{cookiedata === "en" ? window.textTransform(item.JockeyOnRaceDataResult?.NameEn || "-") : item.JockeyOnRaceDataResult?.NameAr || "-"}</div>
                              <div onClick={() => handleShowTrainer(item.TrainerOnRace)} className="new-clickable">{cookiedata === "en" ? window.textTransform(item.TrainerOnRaceDataResult?.NameEn || "-") : item.TrainerOnRaceDataResult?.NameAr || "-"}</div>
                              <div onClick={() => handleShowOwner(item.OwnerId)} className="new-clickable">{cookiedata === "en" ? window.textTransform(item.OwnerIdData?.NameEn || "-") : item.OwnerIdData?.NameAr || "-"}</div>
                              <div className="new-truncate">{cookiedata === "en" ? truncateRaceType(item.RaceResultData?.RaceTypeModelData?.NameEn || "-") : item.RaceResultData?.RaceTypeModelData?.NameAr || "-"}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="new-pagination-wrapper">
                      <Pagination postsPerPage={postsPerPage} totalPosts={QueryTool.totalcount} paginate={paginate} currentPage={currentPage} TotalPages={TotalPages} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* All Modals */}
        <Modal show={show} onHide={handleClose} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><HorseModal data={modaldata} /></Modal.Body></Modal>
        <Modal show={showJockey} onHide={handleCloseJockey} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><JockeyModal data={modaldataJockey} /></Modal.Body></Modal>
        <Modal show={showTrainer} onHide={handleCloseTrainer} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><TrainerModal data={modaldataTrainer} /></Modal.Body></Modal>
        <Modal show={showOwner} onHide={handleCloseOwner} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><OwnerModal data={modaldataOwner} /></Modal.Body></Modal>
        <Modal show={showRace} onHide={handleCloseRace} size="lg" centered className="custom-sha"><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><RaceModal id={modaldataRace} /></Modal.Body></Modal>
        <Footer /><CopyRight />
      </div>
    </>
  );
};
export default Stats;